const components = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 16,
      },
    },
  },
};

export default components;
